/* *******************************************************************
THIS CODE WILL SEND CUSTOM MEALS ATTRIBUTES TO MEALZ API
EVERY TIME USER CLOSES THE WINDOW OR TAB AND HAS CUSTOM MEALS IN CART
******************************************************************** */
document.addEventListener("visibilitychange", logData, false);

function logData() {
  if (
    document.visibilityState === "hidden" ||
    document.visibilityState === "unloaded"
  ) {
    const cart = JSON.parse(localStorage.getItem("_aswm_user_cart"));
    const recartSessionId = localStorage.getItem("RecartSessionId");
    const customMeals = cart?.attributes?.customMeals;
    // it will only save the session if customMeals attribute exists in _aswm_user_cart
    if (customMeals && recartSessionId) {
      console.log("Sending data to mealz api...");
      const form = new FormData();
      form.append("json", JSON.stringify(customMeals));
      form.append("unique_identifier", recartSessionId);
      navigator.sendBeacon("https://mealz.ca/api/recart-session-data", form);
      console.log("Sending data to mealz api... OK!");
    }
  }
}

/* THI CODE WILL CHECK IF LINK HAS QUERY STRINGS FROM RECART
IF YES, IT WILL SAVE THE RECART_SESSION_ID IN LOCALSTORAGE AND KEEP THERE TO BE 
USED IN THE CHECKOUT PAGE - (check in chekout.liquid) */
(function () {
  console.log("RECART-SESSION-ID");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  if (params.utm_campaign === "messenger-abandoned-cart") {
    sessionStorage.setItem(
      "origin_from_recart",
      JSON.stringify({ recartSessionId: params.recart_mid })
    );
    /* it will load PK loading (faster than recart) and remove recart loading */
    document.getElementById("custom-page-loading").style.display = "flex";
    regressiveCutdown();
    // track DOM till get the element
    const observer = new MutationObserver(function (m) {
      const recart_loader = document.getElementById(
        "recart-cart-recovery-overlay"
      );
      if (recart_loader) {
        recart_loader.style.display = "none";
      }
    });
    observer.observe(document.body, { childList: true });
  }
})();

function regressiveCutdown() {
  // Update the count down every 1 second
  let timer = 20;
  const interval = setInterval(() => {
    timer = timer - 1;
    document.getElementById("regressive-counter").innerText = timer + "s";
    if (timer == 0) {
      document.getElementById("custom-page-loading-icon").classList = "fal fa-info-circle fa-3x"
      document.getElementById(
        "custom-page-loading-text"
      ).innerHTML = `<div>Sorry, for some reason your cart could not be retrieved.
      <br/><a href="/" class="homepage-featured-box-btn">
      CONTINUE TO SHOP
      </a></div>`;
      clearInterval(interval);
    }
  }, 1000);
}

function continueShopping() {
  sessionStorage.removeItem("origin_from_recart");
  document.getElementById("custom-page-loading").style.display = "none";
}
